import React from 'react'

import genId from '../utils/gen_id'
import AddIcon from './add-icon'
import Button from './button'
import {useSave} from './object-store'
import useSpinning from './use-spinning'
import WrappingButtons from './wrapping-buttons'
import {decreaseWeight} from './wrktset-editor'
import {increaseWeight} from './wrktset-editor'
import './modal.scss'
import Modal from './modal'



export default function TimerConfigurationModal({onClose, duration, onSetDuration, active, onSetActive}) {
    const innerRef = React.useRef()

    return <Modal stretch onClose={onClose}>
        <div className="spacer spacer--stretch">
            <WrappingButtons
                onTopClick={() => onSetDuration(p => parseInt(p, 10) + 10)}
                onBottomClick={() => onSetDuration(p => parseInt(p, 10) - 10)}
                active
                grow
            >
                <input
                    className="short-input in-m"
                    placeholder="duration (s)"
                    value={duration}
                    onChange={e => onSetDuration(e.target.value)}
                />
            </WrappingButtons>
        </div>
        <label className="spacer spacer--gap">
            <input type="checkbox"
                checked={active}
                onChange={event => onSetActive(prev => !prev)}
            /> ACTIVE
        </label>
    </Modal>
}
